import React from 'react';
import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa';
import * as Fa6Icons from 'react-icons/fa6';
import * as GiIcons from 'react-icons/gi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, style, className, ...props }) => {
  // If a direct component is passed (from react-icons)
  if (icon) {
    return React.createElement(icon, { style, className, ...props });
  }

  // If a name string is passed (legacy/dynamic support)
  let IconComponent = FiIcons[`Fi${name}`];
  
  // Fallback or specific check if needed
  if (!IconComponent) {
    return <FiAlertTriangle style={style} className={className} {...props} />;
  }

  return <IconComponent style={style} className={className} {...props} />;
};

export default SafeIcon;